import React from 'react';
import PropTypes from 'prop-types';

const Label = (props) => {
    let sizes = {
        small: '-label-sm',
        normal: '-label',
        large: '-label-lg',
    };

    const Tag = props.tag;
    const { light, tag, ...safeProps } = props;
    return (
        <Tag
            {...safeProps}
            className={`
                ${sizes[props.size]}
                ${light ? '-light' : ''}
                ${props.className}
            `}
            htmlFor={props.for}>
            {props.children}
        </Tag>
    );
};

Label.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    size: PropTypes.oneOf(['small', 'normal', 'large']),
    for: PropTypes.string,
    light: PropTypes.bool,
    tag: PropTypes.string,
};

Label.defaultProps = {
    className: '',
    size: 'normal',
    light: false,
    tag: 'label',
};

export default Label;
